module.exports = __webpack_public_path__ + "images/landing/banner/help-img-1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/help-img-1.png
// module id = vjsU
// module chunks = 118